<template>
  <div>
    <template v-if="!successState">
      <h6>{{ data.headingText }}</h6>

      <div class="field">
        <input
          v-model.trim="form.email"
          type="text"
          :placeholder="data.emailPlaceholder"
          @input="clearEmailErrors"
        />
        <span v-show="isEmailError" class="error-msg">
          {{ data.emailErrorText }}
        </span>
        <span v-show="isEmailFormatError" class="error-msg">
          {{ data.emailFormatErrorText }}
        </span>
      </div>

      <div class="field">
        <input
          v-model="form.phone"
          type="tel"
          :placeholder="data.phonePlaceholder"
          inputmode="numeric"
          pattern="[0-9]*"
          maxlength="10"
          @input="allowNumbersOnly"
        />

        <span v-show="isPhoneError" class="error-msg">
          {{ data.phoneErrorText }}
        </span>

        <span v-show="isPhoneFormatError" class="error-msg">
          {{ data.phoneFormatErrorText }}
        </span>
      </div>

      <div class="chkbox">
        <h6>{{ data.checkboxText }}</h6>

        <label class="checkbox-label">
          <input
            v-model="form.emailChannel"
            type="checkbox"
            @change="isEmailChannelError = false"
          />
          <span>{{ data.emailText }}</span>
        </label>

        <span v-show="isEmailChannelError" class="error-msg">
          {{ data.emailChannelErrorText }}
        </span>

        <label class="checkbox-label">
          <input v-model="form.smsChannel" type="checkbox" @change="isSmsChannelError = false" />
          <span> {{ data.smsText }}</span>
        </label>

        <span v-show="isSmsChannelError" class="error-msg">
          {{ data.smsChannelErrorText }}
        </span>
      </div>

      <slot name="terms"></slot>

      <button type="button" class="submitbtn" @click="submitForm">
        {{ data.submitText }}
      </button>
    </template>

    <h6 v-else>
      {{ data.successText }}
    </h6>
  </div>
</template>

<script>
export default {
  name: 'footer-form',

  props: {
    data: {
      type: Object,
      default: () => ({
        headingText: 'Footer Form',
        emailPlaceholder: 'Email',
        phonePlaceholder: 'phone',
        emailErrorText: 'Email is required.',
        emailFormatErrorText: 'Please enter a valid email address.',
        phoneErrorText: 'Phone number is required.',
        phoneFormatErrorText: 'Please enter a valid 10-digit phone number.',
        emailChannelErrorText: 'Please select Email.',
        smsChannelErrorText: 'Please select SMS.',
        successText: 'Form Submitted Successfully',
        submitText: 'Submit',
        emailText: 'Email',
        smsText: 'SMS',
        checkboxText: 'Communication Preferences',
        actionUrl: '/api/footer-form',
      }),
    },
  },
  data() {
    return {
      successState: false,
      isEmailError: false,
      isEmailFormatError: false,
      isPhoneError: false,
      isPhoneFormatError: false,
      isEmailChannelError: false,
      isSmsChannelError: false,
      form: {
        email: '',
        phone: '',
        emailChannel: false,
        smsChannel: false,
      },
    };
  },

  methods: {
    validateEmail(email) {
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\d-]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    validateForm() {
      let isValid = true;
      this.isEmailError = false;
      this.isEmailFormatError = false;
      this.isPhoneError = false;
      this.isPhoneFormatError = false;
      this.isEmailChannelError = false;
      this.isSmsChannelError = false;
      if (!this.form.email) {
        this.isEmailError = true;
        isValid = false;
      } else if (!this.validateEmail(this.form.email)) {
        this.isEmailFormatError = true;
        isValid = false;
      }
      if (!this.form.phone) {
        this.isPhoneError = true;
        isValid = false;
      } else if (this.form.phone.length !== 10) {
        this.isPhoneFormatError = true;
        isValid = false;
      }
      if (!this.form.emailChannel) {
        this.isEmailChannelError = true;
        isValid = false;
      }
      if (!this.form.smsChannel) {
        this.isSmsChannelError = true;
        isValid = false;
      }
      return isValid;
    },
    submitForm() {
      if (!this.validateForm()) {
        return;
      }
      console.log('Current Form Values:', this.form);
      fetch(this.data.actionUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(this.form),
      })
        .then((response) => response.json())
        .then((result) => {
          console.log('API Response:', result);
          this.successState = true;
        })
        .catch((error) => {
          console.error('API Error:', error);
        });
    },
    allowNumbersOnly() {
      this.form.phone = this.form.phone.replace(/\D/g, '').slice(0, 10);

      this.isPhoneError = false;

      if (this.form.phone.length === 10) {
        this.isPhoneFormatError = false;
      }
    },
    clearEmailErrors() {
      this.isEmailError = false;
      this.isEmailFormatError = false;
    },
  },
};
</script>
